var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex"},[(_vm.isLoading)?_c('div',{staticClass:"text-center"},[_c('Spinner',{staticClass:"m-auto mb-2"}),_vm._v(" Loading user profile... ")],1):_c('div',{staticClass:"container mt-0 m-auto"},[_c('EditUserProfile',{attrs:{"profile-data":_vm.profile}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }